
import {SHOW_MODAL, AAF_MODAL_SUSPENDED_ACCOUNT, MODAL_POLITICAS, MODAL_POLITICA_DE_PRIVACIDAD,MODAL_TERMINOS_Y_CONDICIONES} from 'src/actions/modal';

export function isSuspendedShowed(action, state) {

    const {type = ''} = action || {};
    const {modalType = ''} = state || {};
    const isSuspendedShowed = type === SHOW_MODAL && modalType === AAF_MODAL_SUSPENDED_ACCOUNT;

    return isSuspendedShowed

}

export function isPoliciesShowed(action, state) {

    const {type = ''} = action || {};
    const {modalType = ''} = state || {};
    const policies = [MODAL_POLITICAS, MODAL_POLITICA_DE_PRIVACIDAD,MODAL_TERMINOS_Y_CONDICIONES]
    const isPoliciesShowed = type === SHOW_MODAL && policies.includes(modalType)

    return isPoliciesShowed

}

export function isPoliciesModal(action, state) {
    const {type = '', modalType = ''} = action || {};
    const policies = [MODAL_POLITICAS, MODAL_POLITICA_DE_PRIVACIDAD,MODAL_TERMINOS_Y_CONDICIONES]
    return type === SHOW_MODAL && policies.includes(modalType)
}

export function isSuspendedModal(action, state) {
    const {type = '', modalType = ''} = action || {};
    return type === SHOW_MODAL && modalType === AAF_MODAL_SUSPENDED_ACCOUNT;
}


// WEBPACK FOOTER //
// ./src/reducers/interceptor.js